import { agent, API_MAP } from 'helpers';

export default class MessagingInternalService {
  static getMessages(pagination?: any) {
    return agent.get(`${API_MAP.messages}?per_page=${pagination.per_page}&page=${pagination.current_page}`);
  }

  static getChats() {
    return agent.get(`${API_MAP.messages}?per_page=200&page=1`);
  }

  static getMessagesChat(id: number) {
    return agent.get(`${API_MAP.messages}/${id}`);
  }

  static sendMessageChat(id: number, content: string, sendEmail: boolean) {
    return agent.post(`${API_MAP.messages}/${id}`, { content, send_email: sendEmail });
  }

  static listProducts() {
    return agent.get(`${API_MAP.messages}/products`);
  }

  static getAffiliates(products: any) {
    return agent.get(`${API_MAP.messages}/products/affiliates`, { params: { products } });
  }

  static sendMessageBroadcast(content: string, customers: any, sendEmail: boolean) {
    return agent.post(`${API_MAP.messages}/broadcast`, { content, customers, send_email: sendEmail });
  }
}
